export const CONTRAT_LABELS = {
  scolaire: 'Assurance scolaire',
  voyage: 'Assurance voyage',
  rcvp: 'Assurance RC Vie Privée',
};
